/* Package JSON Import will be here */
import React, { useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { getTranslate } from "react-localize-redux";
import { Button } from "antd";
/* Package JSON Import will be here */

/* Project Import will be here */
import { changeCaseQuantity, removeAllChangedProductFromOrderReducer } from "reducers/orders";
import { exchangeOrderSummaryChangeCaseQty } from "reducers/exchange/exchangeOrderSummary";
import { ButtonSpinner } from "components/Spinner";
import OrderQtyModal from "components/orders/OrderQtyModal";
import Constants from "utilities/appConstants";
import { checkEligibleForFoc, errorToast } from "utilities/utils";
import modalConfirmationHook from "hooks/modalConfirmationHook";
import { changeFocStatus } from "reducers/common";
/* Project Import will be here */

const ExchangeOrderCaseQtyCounter = (props) => {
    const [isOpenOrderQtyModal, SetIsOpenOrderQtyModal] = useState(false);

    const { orders, cart, appSettings, translate } = useSelector((state) => ({
        orders: state.exchangeOrderSummary,
        cart: state.cart,
        appSettings: state.appSettings,
        translate: getTranslate(state.locale),
    }));

    const dispatch = useDispatch();

    const increment = (e) => {
        e.stopPropagation();
        if (checkForFocValidation) {
            let currentCaseCount = orders.data[props.product.ProductId].case_count;
            let currentCaseCountInPiece = currentCaseCount * props.product.ConversionQty;
            let totalQty = currentCaseCountInPiece + (orders.data[props.product.ProductId].count);
            let case_count = currentCaseCount;

            /* Check for isEnableMinOrderQty logic */
            if (appSettings.isEnableMinOrderQty && props.product.MinORDQty !== 0) {
                /* If the added count of the product is === 0 then directly add the MinOrderQty value */
                if (totalQty === 0) {
                    let caseMiniumQty = (props.product.MinORDQty > props.product.ConversionQty)
                        ?
                        ~~(props.product.MinORDQty / props.product.ConversionQty) + (((props.product.MinORDQty / props.product.ConversionQty) % 1) > 0 ? 1 : 0)
                        :
                        1;

                    case_count = currentCaseCount + caseMiniumQty;
                }

                /* Else if check for it should not exceed the MaxOrderQty value */
                else if ((totalQty + props.product.ConversionQty) > props.product.MaxORDQty && props.product.MaxORDQty !== 0) {
                    errorToast({ content: translate("order.minOrderQty.validationMsg", { count: this.props.product.MaxORDQty }) });
                }
                else {
                    if (props.product.MaxORDQty === 0 || totalQty <= props.product.MaxORDQty)
                        case_count = currentCaseCount + 1;
                    else
                        errorToast({ content: translate("order.minOrderQty.validationMsg", { count: this.props.product.MaxORDQty }) });
                }
            }

            /* If isEnableMinOrderQty is set to false do not check any conditions directly increment the case count to +1 */
            else {
                case_count = currentCaseCount + 1;
            }

            /* Save updated count */
            changeUpdatedCaseQty(case_count);
        }
    };


    const decrement = (e) => {
        e.stopPropagation();

        if (checkForFocValidation) {
            let case_count = 0;
            let currentCaseCount = orders.data[props.product.ProductId].case_count;
            let currentCaseCountInPiece = currentCaseCount * props.product.ConversionQty;
            let totalQty = currentCaseCountInPiece - (orders.data[props.product.ProductId].count);

            /* Check for isEnableMinOrderQty logic */
            if ((appSettings.isEnableMinOrderQty && props.product.MinORDQty !== 0) && totalQty === props.product.MinORDQty)
                case_count = 0;
            else
                case_count = (props.product.MinORDQty > (totalQty - props.product.ConversionQty)) ? 0 : (currentCaseCount - 1);

            /* Save updated count */
            changeUpdatedCaseQty(case_count);
        }
    };

    /* Save updated count */
    const changeUpdatedCaseQty = (updatedCount) => {
        if (updatedCount >= 0 && updatedCount <= 9999) {
            const requestObject = {
                case_count: updatedCount,
                product_id: props.product.ProductId,
                caseChange: true
            };

            if (props.pageType === Constants.EXCHANGE_RETURN_PRODUCT_LIST)
                dispatch(exchangeOrderSummaryChangeCaseQty(requestObject))
            else
                dispatch(changeCaseQuantity(requestObject));
        }
    }

    const checkForFocValidation = () => {
        if (appSettings.isEnableFoc && props.pageType !== Constants.EXCHANGE_RETURN_PRODUCT_LIST) {
            if (checkEligibleForFoc(orders, !props.product.IsSaleable)) {
                return true;
            }
            else {
                /* Check for if any products added in the cart */
                if (cart.ids.length <= 0) {
                    /* Ask for clear the added products in the local */
                    modalConfirmationHook(translate("common.alerts.confirmation.removedAddedFocProductInLocalStoreConfirmationTitle"),
                        translate,
                        (() => {
                            dispatch(removeAllChangedProductFromOrderReducer());
                            dispatch(changeFocStatus(false));
                        }));
                }
                else {
                    errorToast({
                        content: translate("products.foc.focRequestValidation")
                    });
                }
                return false;
            }
        }
        else {
            return true;
        }
    }

    const onQtyChanged = (value) => {
        if (value >= 0 && value <= 9999 && checkForFocValidation()) {
            const requestObject = {
                case_count: Number(value),
                product_id: props.product.ProductId,
                caseChange: true
            };

            if (props.pageType === Constants.EXCHANGE_RETURN_PRODUCT_LIST)
                dispatch(exchangeOrderSummaryChangeCaseQty(requestObject))
            else
                dispatch(changeCaseQuantity(requestObject));
        }
    };

    const openOrderQtyModal = () => {
        SetIsOpenOrderQtyModal(true);
    }

    const closeOrderQtyModal = () => {
        SetIsOpenOrderQtyModal(false);
    }

    return (
        <React.Fragment>
            {!orders.isLoading && orders.data[props.product.ProductId] ? (
                <div className="d-flex align-items-center">
                    {props.product.IsFree ? (
                        <div className="product-quantity d-flex align-items-center">
                            <div className="card-quantity-input">
                                <p className="m-auto">{props.product.caseQTY}</p>
                            </div>
                        </div>
                    ) : (
                        <div className="product-quantity d-flex align-items-center">
                            <Button
                                className={(appSettings.isRestrictSIHProducts && props.product.SIH === 0) ? "product-qul-disabled" : "product-qul"}
                                icon={<i className="icon-minus" />}
                                size="small"
                                onClick={decrement}
                                disabled={appSettings.isRestrictSIHProducts && props.product.SIH === 0}
                            />
                            <div className="card-quantity-input">
                                <Button
                                    type="text"
                                    size="small"
                                    onClick={openOrderQtyModal}
                                    disabled={appSettings.isRestrictSIHProducts && props.product.SIH === 0}
                                >
                                    {orders.data[props.product.ProductId].case_count}
                                </Button>
                            </div>
                            <Button
                                className={(appSettings.isRestrictSIHProducts && props.product.SIH === 0) ? "product-qul-disabled" : "product-qul"}
                                icon={<span className="card-plus-sign">+</span>}
                                size="small"
                                onClick={increment}
                                disabled={appSettings.isRestrictSIHProducts && props.product.SIH === 0}
                            />
                        </div>
                    )}
                </div>)
                :
                        <div className="loding-spinner-div">{orders.isLoading && <ButtonSpinner />}</div>
            }

            {isOpenOrderQtyModal &&
                <OrderQtyModal
                    closeOrderQtyModal={closeOrderQtyModal}
                    onQtyChanged={onQtyChanged}
                    isShowOrderQtyModal={isOpenOrderQtyModal}
                    orders={orders}
                    product={props.product}
                    appSettings={appSettings}
                    pageType={Constants.CASE_QTY}
                />
            }
        </React.Fragment>
    );
}

export default ExchangeOrderCaseQtyCounter;